interface LogoProps {
  /** Rendered square size in px. */
  size?: number;
}

/**
 * The four-square mark. Purely decorative: it always sits next to the wordmark,
 * so announcing it as well would just make a screen reader say "Skabro" twice.
 */
export function LogoMark({ size = 20 }: LogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="var(--sk-accent)"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="0" y="0" width="9" height="9" />
      <rect x="13" y="0" width="9" height="9" opacity=".4" />
      <rect x="0" y="13" width="9" height="9" opacity=".4" />
      <rect x="13" y="13" width="9" height="9" />
    </svg>
  );
}
